import { shelvDesignVariables } from "../../../brandConfig";
import React from "react";
import { Link, useLocation } from "react-router-dom";
import { useAuth } from "../../../contexts/AuthContext";
import { useModulePermissions } from "../../../contexts/ModulePermissionsContext";
import moduleConfig from "../moduleConfig";
import logo from "../assets/wordmark.svg";
import recipesIcon from "../assets/recipes.svg";
import addIcon from "../assets/add.svg";
import calendarIcon from "../assets/calendar.svg";
import "../shelv-design.css";
import { SHELV_UI_SCOPE } from "../ui";

export default function ShelvShell({ children }: { children: React.ReactNode }) {
  const { pathname } = useLocation();
  const { user } = useAuth();
  const { getPermissions } = useModulePermissions();
  const items = (moduleConfig.navigation || []).filter(item => {
    const permissions = getPermissions("shelv", item.permissionLevel || "view");
    return permissions.length > 0 && permissions.some(permission => user?.permissions?.includes(permission));
  });
  const primary = items.filter(item => ["/shelv", "/shelv/capture", "/shelv/calendar", "/shelv/kitchen"].includes(item.path));
  const settings = items.find(item => item.path === "/shelv/settings");
  const secondary = items.filter(item => !primary.includes(item) && item !== settings);
  const navLink = (item: typeof items[number]) => {
    const icon = item.path === "/shelv" ? recipesIcon : item.path === "/shelv/capture" ? addIcon : item.path === "/shelv/calendar" ? calendarIcon : undefined;
    return <Link key={item.path} to={item.path} title={`Open ${item.label}`} className={`shelv-nav-link ${item.path === pathname ? "is-active" : ""}`} aria-current={item.path === pathname ? "page" : undefined}>
      {icon && <img src={icon} alt="" width={16} height={16} />}
      {item.path === "/shelv" ? "Recipes" : item.path === "/shelv/calendar" ? "Meal Plan" : item.label}
      {item.path === "/shelv/calendar" && <span className="shelv-pro-badge">Pro</span>}
    </Link>;
  };
  return <div className={`shelv-shell ${SHELV_UI_SCOPE}`} style={shelvDesignVariables as React.CSSProperties}>
    <aside className="shelv-sidebar">
      <Link to="/shelv" title="Open your recipes"><img className="shelv-sidebar-logo" src={logo} alt="Shelv" width={96} height={28} /></Link>
      <nav aria-label="Shelv">{primary.map(navLink)}
        {secondary.length > 0 && <details className="shelv-more"><summary title="Show more Shelv pages">More</summary>{secondary.map(navLink)}</details>}
      </nav>
      <div className="shelv-pro-card"><strong>Run your whole kitchen</strong><p>Meal planning, ordering, costs and more.</p><Link to="/shelv/calendar" title="Explore Shelv Pro features">Explore Shelv Pro</Link></div>
      <nav className="shelv-account" aria-label="Your account">
        <Link className={`shelv-nav-link ${pathname === "/profile" ? "is-active" : ""}`} aria-current={pathname === "/profile" ? "page" : undefined} to="/profile" title="View your personal information">Personal information</Link>
        <Link className="shelv-nav-link" to="/security" title="Manage your sign-in methods and account security">Security</Link>
        {settings && <Link className={`shelv-nav-link ${pathname === "/shelv/settings" ? "is-active" : ""}`} aria-current={pathname === "/shelv/settings" ? "page" : undefined} to="/shelv/settings" title="Point Shelv's recipe, photo and web readers at the right services">Shelv settings</Link>}
      </nav>
    </aside>
    <main className="shelv-main">{children}</main>
  </div>;
}
